import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Sales.ContractRefund.RefundPricingInfo.IParams;
type Request = Api.Sales.ContractRefund.RefundPricingInfo.IRequest;
type Response = Api.Sales.ContractRefund.RefundPricingInfo.IResponse;
type Headers = Api.Sales.ContractRefund.RefundPricingInfo.IHeaders;
const url = '/api/Sales/ContractRefund/RefundPricingInfo/:contractId';
export default async function contractRefundPricingInfoApi(params: Params, body: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params, null),
    body,
    headers: getDefaultHeaders(),
  });
}
